import {
  ReactNode,
  HTMLAttributes,
  ThHTMLAttributes,
  TdHTMLAttributes,
  TableHTMLAttributes,
} from "react";
import clsx from "clsx";

// ------------------------ Table Components ------------------------

type TableProps = TableHTMLAttributes<HTMLTableElement> & {
  children?: ReactNode;
  className?: string;
};

const Table = ({ children, className = "", ...props }: TableProps) => (
  <table className={clsx("default_table", className)} {...props}>
    {children}
  </table>
);

type TableHeadProps = HTMLAttributes<HTMLTableSectionElement> & {
  children?: ReactNode;
  className?: string;
};

const TableHead = ({ children, className = "", ...props }: TableHeadProps) => (
  <thead className={clsx("default_table_head", className)} {...props}>
    {children}
  </thead>
);

type TableBodyProps = HTMLAttributes<HTMLTableSectionElement> & {
  children?: ReactNode;
  className?: string;
};

const TableBody = ({ children, className = "", ...props }: TableBodyProps) => (
  <tbody className={clsx("default_table_body", className)} {...props}>
    {children}
  </tbody>
);

type TableRowProps = HTMLAttributes<HTMLTableRowElement> & {
  children?: ReactNode;
  className?: string;
};

const TableRow = ({ children, className = "", ...props }: TableRowProps) => (
  <tr className={clsx("default_table_row", className)} {...props}>
    {children}
  </tr>
);

type TableHeaderCellProps = ThHTMLAttributes<HTMLTableHeaderCellElement> & {
  children?: ReactNode;
  className?: string;
};

const TableHeaderCell = ({ children, className = "", ...props }: TableHeaderCellProps) => (
  <th className={clsx("default_th", className)} {...props}>
    {children}
  </th>
);

type TableDataCellProps = TdHTMLAttributes<HTMLTableDataCellElement> & {
  children?: ReactNode;
  className?: string;
};

const TableDataCell = ({ children, className = "", ...props }: TableDataCellProps) => (
  <td className={clsx("default_td", className)} {...props}>
    {children}
  </td>
);

// ------------------------ Semantic Layout Components ------------------------

type HeaderProps = HTMLAttributes<HTMLElement> & {
  children?: ReactNode;
  className?: string;
};

const Header = ({ children, className = "", ...props }: HeaderProps) => (
  <header className={clsx("default_header", className)} {...props}>
    {children}
  </header>
);

type NavigationProps = HTMLAttributes<HTMLElement> & {
  children?: ReactNode;
  className?: string;
};

const Navigation = ({ children, className = "", ...props }: NavigationProps) => (
  <nav className={clsx("default_nav", className)} {...props}>
    {children}
  </nav>
);

type SectionProps = HTMLAttributes<HTMLElement> & {
  children?: ReactNode;
  className?: string;
};

const Section = ({ children, className = "", ...props }: SectionProps) => (
  <section className={clsx("default_section", className)} {...props}>
    {children}
  </section>
);

type MainProps = HTMLAttributes<HTMLElement> & {
  children?: ReactNode;
  className?: string;
};

const Main = ({ children, className = "", ...props }: MainProps) => (
  <main className={clsx("default_main", className)} {...props}>
    {children}
  </main>
);

type FooterProps = HTMLAttributes<HTMLElement> & {
  children?: ReactNode;
  className?: string;
};

const Footer = ({ children, className = "", ...props }: FooterProps) => (
  <footer className={clsx("default_footer", className)} {...props}>
    {children}
  </footer>
);

// ------------------------ Exports ------------------------

export {
  Header,
  Footer,
  Main,
  Navigation,
  Section,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableHeaderCell,
  TableDataCell,
};
